import * as fromDatatype from '../datatype-library/index';

export interface bl_ppl_ap_participant_registration_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_name: fromDatatype.VarcharArrayDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_id: fromDatatype.VarcharArrayDatatypeInterface;
  country_code: fromDatatype.VarcharArrayDatatypeInterface;
  phone: fromDatatype.VarcharArrayDatatypeInterface;
  email: fromDatatype.VarcharArrayDatatypeInterface;
  state: fromDatatype.VarcharArrayDatatypeInterface;
  additional_identifier: fromDatatype.VarcharArrayDatatypeInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;  
  status : fromDatatype.StatusDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
  kyc_file_guid: fromDatatype.GuidDataFieldInterface;
  peppol_participant_id: fromDatatype.VarcharDatatypeInterface;
}

export class bl_ppl_ap_participant_registration_hdr_RowClass implements bl_ppl_ap_participant_registration_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_name: fromDatatype.VarcharArrayDatatypeInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_id: fromDatatype.VarcharArrayDatatypeInterface;
  country_code: fromDatatype.VarcharArrayDatatypeInterface;
  phone: fromDatatype.VarcharArrayDatatypeInterface;
  email: fromDatatype.VarcharArrayDatatypeInterface;
  state: fromDatatype.VarcharArrayDatatypeInterface;
  additional_identifier: fromDatatype.VarcharArrayDatatypeInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision : fromDatatype.GuidDataFieldInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;  
  status : fromDatatype.StatusDataFieldInterface;
  tenant_code: fromDatatype.VarcharDatatypeInterface;
  kyc_file_guid: fromDatatype.GuidDataFieldInterface;
  peppol_participant_id: fromDatatype.VarcharDatatypeInterface;
}
